import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import {
  De_generateReferralLetterDocumentInput,
  useDeGenerateReferralDocumentMutation as useDeGenerateReferralDocumentMutationType,
} from "@/modules/patients/detail/referral/de/services/__generated__/useDeGenerateReferralDocumentMutation.graphql"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const generateDocumentMutation = graphql`
  mutation useDeGenerateReferralDocumentMutation($input: De_generateReferralLetterDocumentInput!) {
    de_generateReferralLetterDocument(input: $input) {
      de_ReferralLetter {
        patientId
        progressNoteId
        id
        fileId
        icdDiagnosis {
          id
          isAssociation
          diagnosisCode
          primaryCode
          secondaryCode
          associationType
          text
        }
        reasoning
        createdBy
        createdAt
        updatedBy
        updatedAt
        signedAt
        signedBy
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeGenerateReferralDocumentMutationType>, "variables"> & {
  params: Omit<
    De_generateReferralLetterDocumentInput,
    | "patientLastName"
    | "patientFirstName"
    | "phoneNumber"
    | "zipCode"
    | "houseStreetNumber"
    | "city"
    | "gender"
    | "dateOfBirth"
    | "patientId"
  >
}
const useDeGenerateReferralDocumentMutation = () => {
  const [commit, isFlight] = useMutation<useDeGenerateReferralDocumentMutationType>(generateDocumentMutation)
  const patientById = usePatientParam()

  const commitHandler = useCallback(
    (config: Config) => {
      commit({
        variables: {
          input: {
            patientId: patientById,
            allergies: config.params.allergies,
            conditions: config.params.conditions,
            dateOfConsultation: config.params.dateOfConsultation,
            episodeOfCare: config.params.episodeOfCare,
            id: config.params.id,
            medications: config.params.medications,
            reasoning: config.params.reasoning,
            specialtyName: config.params.specialtyName,
          },
        },
        ...config,
      })
    },
    [commit, patientById],
  )

  return [commitHandler, isFlight] as const
}

export { useDeGenerateReferralDocumentMutation }
